module.exports = __webpack_public_path__ + "666852ecc66f95734bd802d51626002a.png";